import navs from './states/navs'
import features from './states/features'
import taxes from './states/taxes'

const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null
const token = localStorage.getItem('token') ? localStorage.getItem('token') : null
const service_name = localStorage.getItem('service_name') ? localStorage.getItem('service_name') : '';
const langObj = {
  uz: 'O\'zbek',
  en: 'English',
  ru: 'Русский'
}
const lang = localStorage.getItem('lang') && langObj[localStorage.getItem('lang')] ? {text: langObj[localStorage.getItem('lang')], value: localStorage.getItem('lang')} : {text: 'English', value: 'en'}
const nav_obj = localStorage.getItem('nav_obj') ? JSON.parse(localStorage.getItem('nav_obj')) : []
const mini_variant = localStorage.getItem('mini_variant') == 'true' ? true : false
const now = new Date()
const datee = new Date(new Date().setDate(now.getDate())).toISOString().substr(0, 10)

const options = localStorage.getItem('options') ? JSON.parse(localStorage.getItem('options')) : {
  start_date: new Date(new Date().setDate(now.getDate() - 7))
    .toISOString()
    .substr(0, 10),
  end_date: new Date(new Date().setDate(now.getDate()))
    .toISOString()
    .substr(0, 10),
  custom: false,
  employee: null,
  category: null,
  supplier: null,
  reason: {
    name: "All reasons",
    value: ""
  },
  start: {text: "12 AM", time: 0},
  end: {text: "12 PM", time: 12}
}

const items_current_service = localStorage.getItem('items_current_service') ? JSON.parse(localStorage.getItem('items_current_service')) : {_id: ''}
const items_current_page = localStorage.getItem('items_current_page') && +localStorage.getItem('items_current_page') ? +localStorage.getItem('items_current_page') : 1
const items_current_limit = localStorage.getItem('items_current_limit') ? localStorage.getItem('items_current_limit') : 10

const access = localStorage.getItem('access') ? JSON.parse(localStorage.getItem('access')) : null
const item_list_headers = localStorage.getItem('item_list_headers') ? JSON.parse(localStorage.getItem('item_list_headers')):null

const currentCurrency = localStorage.getItem('currentCurrency') ? localStorage.getItem('currentCurrency') : 'uzs';
let currencyZeros = localStorage.getItem('currencyZeros') ? +localStorage.getItem('currencyZeros') : 2;
if (currencyZeros < 2) {
  currencyZeros = 2
}

const sort_by = localStorage.getItem('sort_by') ? localStorage.getItem('sort_by') : 'date';

const receipt_number = +localStorage.getItem('receipt_number') ? +localStorage.getItem('receipt_number') : 1;

const receipt_letter = localStorage.getItem('receipt_letter') ? localStorage.getItem('receipt_letter') : null;

const lastLabel = +localStorage.getItem('lastLabel') ? +localStorage.getItem('lastLabel') : 4;

const glSearch = ""

let main_supplier = {
  _id: "",
  name: ""
}

const main_store = {name: "All stores", _id: ""}

let rand_supplier_in_items_list = {supplier_name: "EE", _id: ""}

const supplier1 = localStorage.getItem('supplier1') ? JSON.parse(localStorage.getItem('supplier1')) : {_id: ''}
const category1 = localStorage.getItem('category1') ? JSON.parse(localStorage.getItem('category1')) : {_id: ''}
const status1 = localStorage.getItem('status1') ? JSON.parse(localStorage.getItem('status1')) : {value: ''}
const type_pur = localStorage.getItem('type_pur') ? JSON.parse(localStorage.getItem('type_pur')) : {value: ''}
const stock_item = localStorage.getItem('stock_item') ? JSON.parse(localStorage.getItem('stock_item')) : {value: 'all'}
const supplier_id_for_item = ''

const suppValPage = 1

const partition_valuation_by_supplier = ''
export default {
  user: user,
  token: token,
  receipt_number,
  service_name: service_name,
  nav_obj: nav_obj,
  mini_variant,
  options: options,
  lang: lang,
  lastLabel,
  langs: [{text: 'English', value: 'en'}, {text: 'O\'zbek', value: 'uz'}, {text: 'Русский', value: 'ru'}],
  payment_types: [],
  loyalty: {loyalty_bonus: 0.0},
  tickets: {
    is_ticket: false,
    tickets: [],
  },
  items_current_service,
  items_current_page,
  items_current_limit,
  items_current_sort_by: sort_by,
  access,
  item_list_headers,
  currentCurrency,
  currencyZeros,
  ...navs,
  ...features,
  ...taxes,
  receipt_letter,
  glSearch,
  main_supplier,
  main_store,
  rand_supplier_in_items_list,
  supplier1,
  category1,
  status1,
  type_pur,
  suppValPage,
  datee,
  supplier_id_for_item,
  partition_valuation_by_supplier,
  stock_item
}
